import { Component, OnInit, Input } from '@angular/core';
import { SmartLabelService } from '../smart-label.service';
import { SmartLabelTemplate } from '../smart-label-template';
import { PageService } from '../../../services/page.service';
import { AppService } from '../../../services/app.service';
import { ShortCodePipe } from "../../../pipes/short-code.pipe";
import { MultiLangPipe } from "../../../pipes/multi-lang.pipe";
import { faUtensils } from '@fortawesome/free-solid-svg-icons';
import { FOOD_LANG } from '../FOOD_LANG';
import { ListItemComponent } from '../../list/list-item/list-item.component';

@Component({
  selector: 'smart-label-food',
  templateUrl: './smart-label-food.component.html',
  styleUrls: ['../smart-label.component.scss', './smart-label-food.component.scss']
})
export class SmartLabelFoodComponent extends SmartLabelTemplate implements OnInit {
  @Input() config;
  @Input() smartLabelData;
  @Input() entityInformation;

  pageAlias = '';
  privacyPolicyUrl;

  //Configs
  headerConfig: any;
  tabConfig: any = { config: null };
  productHeaderConfig: any;
  footerLinksConfig;
  footer1Config: any;
  footer2Config: any;
  socialLinksConfig: any;
  nutritionFactsConfig: Array<any>;
  nutrientHeaderConfig: any;
  allergensFoodHeaderConfig: any;
  allergensFoodListConfig: any;
  servingSizeSelectorConfig: any;
  microNutrients_USA: Array<string> = ['VITD-', 'CA', 'FE', 'K', 'VITA-', 'VITC-', 'VITE-', 'VITK', 'THIA', 'RIBF', 'NIA', 'VITB6-', 'FOL-', 'VITB12', 'BIOT', 'PANTAC', 'P', 'ID', 'MG', 'ZN', 'SE', 'CU', 'MN', 'CR', 'MO', 'CLD', 'CHOLN']
  microNutrients_CA: Array<string> = ['K', 'CA', 'FE', 'VITD-', 'VITA-', 'VITC-', 'VITE-', 'VITK', 'THIA', 'RIBF', 'NIA', 'VITB6-', 'FOL-', 'VITB12', 'BIOT', 'PANTAC', 'P', 'ID', 'MG', 'ZN', 'SE', 'CU', 'MN', 'CR', 'MO', 'CLD', 'CHOLN']
  foodIngredientsListConfig: any;
  informationAccuracyConfig: any
  badgeConfig: any;
  dailyValue = [
    {
      "languageCode": "en",
      "value": "% Daily Value*"
    },
    {
      "languageCode": "fr",
      "value": "% valeur quotidienne*"
    },
    {
      "languageCode": "en_CA",
      "value": "% Daily Value*"
    },
    {
      "languageCode": "fr_CA",
      "value": "% valeur quotidienne*"
    },
    {
      "languageCode": "en_US",
      "value": "% Daily Value*"
    }
  ];
  space = '';
  allergenCodes_USA: Array<string> = ['AM', 'AE', 'AF', 'UN', 'TN', 'AP', 'UW', 'AY'];
  allergenCodes_CA: Array<string> = ['AM', 'AE', 'AF', 'UN', 'TN', 'AP', 'UW', 'AY', 'BM', 'AS'];
  //Data
  gpcCategoryCodePath: string = 'data.modules.BasicProductInformationModuleType.gpcCategoryCode';
  brandNamePath: string = 'data.modules.BasicProductInformationModuleType.brandNameInformation.brandName';
  categoryPath: string = 'data.modules.BasicProductInformationModuleType.gpcCategoryCode';
  productImageUrlPath: string = 'data.modules.BasicProductInformationModuleType.imageLink';
  foodIngredientInformationPath: string = "data.modules.FoodAndBeverageIngredientInformationModuleType";
  ingredientsListConfig: any;
  constructor(private smartLabelService: SmartLabelService,
    private pageService: PageService,
    private appService: AppService,
    public shortCodePipe: ShortCodePipe,
    public multiLangPipe: MultiLangPipe) {
    super();
  }

  /**
   * Header and Footer for the Smartlabel (Food) digital Interaction
   * @author - Venkatesh Pasala
   * @task - QLIKTAG-2888
   */
  ngOnInit() {
    // console.log('init')
    this.pageAlias = this.pageService.pageAlias;
    this.smartLabelService.smartLabelData = this.smartLabelData;
    this.smartLabelService.smartLabelConfig = this.config;
    this.privacyPolicyUrl = this.smartLabelService.getPrivacyPolicyUrl(this.config);
    this.headerConfig = {
      "ctrlName": "header",
      "config": {
        "sticky": true,
        "isBackButtonVisible": false,
        "isMenuButtonVisible": false,
        "isContentHeader": true,
        "bgImageColor": "#FFFFFF",
        "class": 'smartlabel-header'
      }
    }
    this.productHeaderConfig = this.smartLabelService.getProductHeaderConfig();
    if (this.config.hasOwnProperty('footer1')) {
      this.footer1Config = {
        "ctrlName": "rich-text",
        "config": {
          "class": "smartlabel-rich-text smartlabel-footer m-b-10",
          "content": this.config.footer1,
        }
      }
    }
    if (this.config.hasOwnProperty('footer2')) {
      this.footer2Config = {
        "ctrlName": "rich-text",
        "config": {
          "class": "smartlabel-rich-text smartlabel-footer",
          "content": this.config.footer2,
        }
      }
    }
    this.footerLinksConfig = {
      "ctrlName": "footer-links",
      "config": {
        "class": "smartlabel-footer-links",
        "links": [
          ...(this.privacyPolicyUrl ? [this.privacyPolicyUrl] : [])
        ]
      }
    }
    this.socialLinksConfig = this.smartLabelService.getSocialLinksConfig();
    this.servingSizeSelectorConfig = this.getServingSizeSelectorConfig();
    this.nutritionFactsConfig = this.getNutritionFacts(0);
    this.nutrientHeaderConfig = this.getNutrientHeaderConfig(0);
    this.allergensFoodHeaderConfig = this.getAllergensFoodHeaderConfig();
    this.allergensFoodListConfig = this.getAllergensFoodListConfig();
    //tab 2
    //this.foodIngredientsListConfig = this.getIngredientsList();
    this.ingredientsListConfig = this.getIngredientsList()
    this.informationAccuracyConfig = this.smartLabelService.getInformationAccuracyConfig();
    this.tabConfig =
    {
      "ctrlName": "tabs",
      "config": {
        "class": 'smartlabel-tabs',
        "value": 'nutrition',
        "layout": 'icon-top',
        "scrollable": false,
        "tabs": 5,
        "sticky": true,
        "gridFixed": true
      },
      "controls": [
        {
          "ctrlName": "tab-item",
          "config": {
            "name": this.smartLabelService.getTabName(0),
            "title": this.smartLabelService.getTabTitle(0),
            "icon": this.smartLabelService.getTabIcon(0),
            "show": true
          },
          "controls": [
            ...(this.servingSizeSelectorConfig ? [this.servingSizeSelectorConfig] : []),
            ...(this.nutrientHeaderConfig ? [this.nutrientHeaderConfig] : []),
            ...(this.nutritionFactsConfig ? this.nutritionFactsConfig : [])
          ]
        },
        {
          "ctrlName": "tab-item",
          "config": {
            "name": this.smartLabelService.getTabName(1),
            "title": this.smartLabelService.getTabTitle(1),
            "icon": this.smartLabelService.getTabIcon(1),
            "show": true
          },
          "controls": [
            ...(this.ingredientsListConfig ? [this.ingredientsListConfig] : [])
            // ...(this.foodIngredientsListConfig && this.foodIngredientsListConfig.length > 0 ? this.foodIngredientsListConfig : [])
          ]
        },
        {
          "ctrlName": "tab-item",
          "config": {
            "name": this.smartLabelService.getTabName(2),
            "title": this.smartLabelService.getTabTitle(2),
            "icon": this.smartLabelService.getTabIcon(2),
            "show": true
          },
          "controls": [
            ...(this.allergensFoodHeaderConfig ? this.allergensFoodHeaderConfig : []),
            ...(this.allergensFoodListConfig ? this.allergensFoodListConfig : [])
          ]
        },
        {
          "ctrlName": "tab-item",
          "config": {
            "name": this.smartLabelService.getTabName(3),
            "title": this.smartLabelService.getTabTitle(3),
            "icon": this.smartLabelService.getTabIcon(3),
            "show": true
          },
          "controls": [
            this.getFeaturesAndBenefitsConfig()
          ]
        },
        {
          "ctrlName": "tab-item",
          "config": {
            "name": this.smartLabelService.getTabName(4),
            "title": this.smartLabelService.getTabTitle(4),
            "icon": this.smartLabelService.getTabIcon(4),
            "show": true
          },
          "controls": [
            this.smartLabelService.getContactTabsConfig(),
            this.smartLabelService.getExternalLinksConfig(this.config)
          ]
        }

      ]
    }
    //event triggered when selector option is changed    
    this.smartLabelService.smartLabelEvents$.subscribe((data) => {
      //console.log("subscribe tp event" , data)

      if (data.hasOwnProperty("payload") && data['payload'].hasOwnProperty('type')) {
        if (data['payload']['type'] === 'serving-size') {
          this.nutrientHeaderConfig = this.getNutrientHeaderConfig(data['payload']['value']);
          //console.log("nutrientHeaderConfig", this.nutrientHeaderConfig);
          this.tabConfig.controls[0].controls[1] = this.nutrientHeaderConfig;
          //get nutrient facts config for selected index of nutrientHeader
          this.nutritionFactsConfig = this.getNutritionFacts(data['payload']['value']);
          //console.log(this.tabConfig.controls[0].controls[2], this.nutritionFactsConfig[0]);
          //console.log(this.tabConfig.controls[0].controls[2], this.nutritionFactsConfig[0])
          //replace conditional control for USA
          this.tabConfig.controls[0].controls[2] = this.nutritionFactsConfig[0];
          //replace conditional control for Canada
          this.tabConfig.controls[0].controls[3] = this.nutritionFactsConfig[1];
        }
      }
    });

    this.badgeConfig = this.smartLabelService.getBadgeConfig();
  }

  /**
   * header config for nutrient facts page
   * @author Radhika Agnihotri
   * @task QLIKTAG-3584
   */
  getNutrientHeaderConfig(index: number = 0) {
    let calorieBlock = this.getCalories(index);
    let satFatBlock = this.getSatFat(index);
    let sodiumBlock = this.getSodium(index);
    let sugarBlock = this.getSugar(index);
    let result = {
      "ctrlName": "rich-text",
      "config": {
        "class": "smartlabel-rich-text smartlabel-nutrition-count",
        "content": `
        <ion-grid fixed="true">
          <ion-row align-items-stretch>
            ${calorieBlock ? calorieBlock : ''}
            ${satFatBlock ? satFatBlock : ''}
            ${sodiumBlock ? sodiumBlock : ''}
            ${sugarBlock ? sugarBlock : ''}
          </ion-row>
        </ion-grid>
     <hr class="smartlabel-separator">`
      }
    }
    return result;
  }

  /**
   * get calories html layout
   * @author Radhika Agnihotri
   * @task QLITKAG-3584
   */
  getCalories(index: number) {
    let result;
    //get index
    let nutrientDetailPath = `data.modules.NutritionalProductInformationModuleType.nutrientHeader.${index}.nutrientDetail`;
    let path = nutrientDetailPath.split('.');
    const nutrientDetail = this.appService.findObjectByPath(this.smartLabelData, path);
    let nutrientIndex: number = -1;
    if (nutrientDetail) {
      nutrientIndex = nutrientDetail.findIndex(item => item.nutrientTypeCode === 'ENER-');
    }
    let calorieValue = '0';

    if (nutrientIndex != -1) {
      let calorieItem = nutrientDetail[nutrientIndex];
      if (calorieItem.hasOwnProperty('quantityContained') && calorieItem['quantityContained'].length > 0) {
        if (calorieItem['quantityContained'][0].hasOwnProperty('value')) {
          calorieValue = calorieItem['quantityContained'][0]['value'];
        }
      }
    }
    result = `
    <ion-col>
      <div class="count">
        <span>${calorieValue}</span>
        <div class="para">Calories</div>
      </div>
    </ion-col>`;
    return result;
  }

  /**
   * get saturated fats html layout
   * @author Radhika Agnihotri
   * @task QLIKTAG-3584
   */
  getSatFat(index: number) {
    let result;
    //get index
    let nutrientDetailPath = `data.modules.NutritionalProductInformationModuleType.nutrientHeader.${index}.nutrientDetail`
    let path = nutrientDetailPath.split('.');
    const nutrientDetail = this.appService.findObjectByPath(this.smartLabelData, path);
    let nutrientIndex: number = -1;
    if (nutrientDetail) {
      nutrientIndex = nutrientDetail.findIndex(item => item.nutrientTypeCode === 'FASAT');
    }
    let satFatValue = '0';
    let measurementUnitCode = 'g';
    let nutrientCode = 'Sat Fat';
    //get object returned from getNutrientByCode
    if (nutrientIndex != -1) {
      let satFatItem = nutrientDetail[nutrientIndex];

      if (satFatItem.hasOwnProperty('quantityContained') && satFatItem['quantityContained'].length > 0) {
        if (satFatItem['quantityContained'][0].hasOwnProperty('value')) {
          satFatValue = satFatItem['quantityContained'][0]['value'];
        }
        measurementUnitCode = this.shortCodePipe.transform(`{{SL.${nutrientDetailPath}.${nutrientIndex}.quantityContained.0.measurementUnitCode | mapTo: listItemName}}`);
      }

      nutrientCode = this.shortCodePipe.transform(`{{SL.${nutrientDetailPath}.${nutrientIndex}.nutrientTypeCode| mapTo: listItemName}}`);

    }

    result = `
    <ion-col>
      <div class="count">
        <span>${satFatValue}</span>
        <div class="para">${nutrientCode}  ${measurementUnitCode ? `(${measurementUnitCode})` : ''}</div>
      </div>
    </ion-col>`;

    return result;
  }
  /**
   * get sodium html layout
   * @author Radhika Agnihotri
   * @task QLITKAG-3584
   */
  getSodium(index: number) {
    let result;
    //get index
    let nutrientDetailPath = `data.modules.NutritionalProductInformationModuleType.nutrientHeader.${index}.nutrientDetail`;
    let path = nutrientDetailPath.split('.');
    const nutrientDetail = this.appService.findObjectByPath(this.smartLabelData, path);
    let nutrientIndex: number = -1;
    if (nutrientDetail) {
      nutrientIndex = nutrientDetail.findIndex(item => item.nutrientTypeCode === 'NA')
    }
    let sodiumValue = '0';
    let measurementUnitCode = 'mg';
    let nutrientCode = 'Sodium';

    if (nutrientIndex != -1) {
      let sodiumItem = nutrientDetail[nutrientIndex];

      if (sodiumItem.hasOwnProperty('quantityContained') && sodiumItem['quantityContained'].length > 0) {
        if (sodiumItem['quantityContained'][0].hasOwnProperty('value')) {
          sodiumValue = sodiumItem['quantityContained'][0]['value'];
        }
        measurementUnitCode = this.shortCodePipe.transform(`{{SL.${nutrientDetailPath}.${nutrientIndex}.quantityContained.0.measurementUnitCode | mapTo: listItemName}}`);

      }

      nutrientCode = this.shortCodePipe.transform(`{{SL.${nutrientDetailPath}.${nutrientIndex}.nutrientTypeCode| mapTo: listItemName}}`)

    }

    result = `
    <ion-col>
      <div class="count">
        <span>${sodiumValue}</span>
        <div class="para">${nutrientCode}  ${measurementUnitCode ? `(${measurementUnitCode})` : ''}</div>
      </div>
    </ion-col>`;

    return result;
  }

  /**
   * get sugar html layout
   * @author Radhika Agnihotri
   * @task QLIKTAG-3584
   */
  getSugar(index: number) {
    let result;
    //get index
    let nutrientDetailPath = `data.modules.NutritionalProductInformationModuleType.nutrientHeader.${index}.nutrientDetail`
    let path = nutrientDetailPath.split('.');
    const nutrientDetail = this.appService.findObjectByPath(this.smartLabelData, path);
    let nutrientIndex: number = -1;
    if (nutrientDetail) {
      nutrientIndex = nutrientDetail.findIndex(item => item.nutrientTypeCode === 'SUGAR-')
    }

    let sugarValue = '0';
    let measurementUnitCode = 'g';
    let nutrientCode = 'Total Sugars';

    if (nutrientIndex != -1) {
      let sugarItem = nutrientDetail[nutrientIndex];

      if (sugarItem.hasOwnProperty('quantityContained') && sugarItem['quantityContained'].length > 0) {
        if (sugarItem['quantityContained'][0].hasOwnProperty('value')) {
          sugarValue = sugarItem['quantityContained'][0]['value'];
        }
        measurementUnitCode = this.shortCodePipe.transform(`{{SL.${nutrientDetailPath}.${nutrientIndex}.quantityContained.0.measurementUnitCode | mapTo: listItemName}}`);

      }

      nutrientCode = this.shortCodePipe.transform(`{{SL.${nutrientDetailPath}.${nutrientIndex}.nutrientTypeCode| mapTo: listItemName}}`)

    }

    result = `
    <ion-col>
      <div class="count">
        <span>${sugarValue}</span>
        <div class="para">${nutrientCode}  ${measurementUnitCode ? `(${measurementUnitCode})` : ''}</div>
      </div>
    </ion-col>`;

    return result;
  }

  /**
   * get nutrient facts list
   * @author Radhika Agnihotri
   * @task QLIKTAG-2898
   */
  getNutritionFacts(index: number = 0) {
    //console.log("getnutritionFacets", index)
    let result = [];
    let nutritionFacts_US = this.getNutritionFacts_US(index);
    let nutritionFacts_CA = this.getNutritionFacts_CA(index);
    //return empty array if nutrientHeader does not have nutrientDetail value
    let nutrientDetailPath = `data.modules.NutritionalProductInformationModuleType.nutrientHeader.${index}.nutrientDetail`
    let path = nutrientDetailPath.split('.');
    const nutrientDetail = this.appService.findObjectByPath(this.smartLabelData, path);

    if (!nutrientDetail) {
      return result;
    }

    //check if dailyValueIntakeReference is present in data
    let dailyValueIntakeReference;
    let nutrientHeaderPath = `data.modules.NutritionalProductInformationModuleType.nutrientHeader.${index}`
    path = nutrientHeaderPath.split('.');
    const nutrientHeader = this.appService.findObjectByPath(this.smartLabelData, path);

    if (nutrientHeader && nutrientHeader.hasOwnProperty('dailyValueIntakeReference')) {
      dailyValueIntakeReference = this.multiLangPipe.transform(nutrientHeader['dailyValueIntakeReference']);
    }
    let attributeKey = 'product.targetMarket';
    if (this.smartLabelService.isProductEntity) {
      attributeKey = 'targetMarket';
    }
    let footer = [
      {
        "languageCode": "en",
        "value": `*5% or less is <span class="f-w-700">a little</span>, 15% or more is <span class="f-w-700">a lot</span><br/>`
      },
      {
        "languageCode": "fr",
        "value": `*5% ou moins c'est <span class="f-w-700">peu</span>, 15% ou plus c'est <span class="f-w-700">beaucoup</span><br/>`
      },
      {
        "languageCode": "en_CA",
        "value": `*5% or less is <span class="f-w-700">a little</span>, 15% or more is <span class="f-w-700">a lot</span><br/>`
      },
      {
        "languageCode": "fr_CA",
        "value": `*5% ou moins c'est <span class="f-w-700">peu</span>, 15% ou plus c'est <span class="f-w-700">beaucoup</span><br/>`
      },
      {
        "languageCode": "en_US",
        "value": `*5% or less is <span class="f-w-700">a little</span>, 15% or more is <span class="f-w-700">a lot</span><br/>`
      }
    ]
    let footerText = this.multiLangPipe.transform(footer);
    result.push({
      "ctrlName": "conditional",
      "config": {
        "source": "entityInformation",
        "action": "show",
        "operator": "matches",
        "mapping": {
          "attributeKey": attributeKey
        },
        "attributeValue": "840",
        "class": "smartlabel-nutrition-table"
      },
      "controls": [
        {
          "ctrlName": "rich-text",
          "config": {
            "class": "smartlabel-rich-text",
            "content": `<h2 class="text-center table-header">Nutrition Facts</h2>`
          }
        },
        nutritionFacts_US,
        {
          "ctrlName": "rich-text",
          "config": {
            "class": "smartlabel-rich-text p-10 f-12",
            "content": `* The % Daily Value (DV) tells you how much a nutrient in a serving of food contributes to a daily diet. 2,000 calories a day is used for general nutrition advice.<br/> ${dailyValueIntakeReference ? `${dailyValueIntakeReference}` : ''}`
          }
        }
      ]
    });
    let nutritionFacts = [
      {
        "languageCode": "en",
        "value": "Nutrition Facts"
      },
      {
        "languageCode": "fr",
        "value": "Valeur Nutritive"
      },
      {
        "languageCode": "en_CA",
        "value": "Nutrition Facts"
      },
      {
        "languageCode": "fr_CA",
        "value": "Valeur Nutritive"
      },
      {
        "languageCode": "en_US",
        "value": "Nutrition Facts"
      }
    ]
    let nutritionFactsText = this.multiLangPipe.transform(nutritionFacts);
    result.push({
      "ctrlName": "conditional",
      "config": {
        "source": "entityInformation",
        "action": "show",
        "operator": "matches",
        "mapping": {
          "attributeKey": attributeKey
        },
        "attributeValue": "124",
        "class": "smartlabel-nutrition-table"
      },
      "controls": [
        {
          "ctrlName": "rich-text",
          "config": {
            "class": "smartlabel-rich-text",
            "content": `<h2 class="table-header">${nutritionFactsText}</h2>`
          }
        },
        nutritionFacts_CA,
        {
          "ctrlName": "rich-text",
          "config": {
            "class": "smartlabel-rich-text p-10 f-12",
            "content": `${footerText} ${dailyValueIntakeReference ? `${dailyValueIntakeReference}` : ''}`
          }
        }
      ]
    });
    //console.log("result", result)
    return result;
  }

  /**
   * return list control for nutrition Facts USA
   * @author Radhika Agnihotri
   * @tasK QLIKTAG-2898
   */
  getNutritionFacts_US(index: number) {
    //console.log("getNutritionFacts_US index", index);
    //serving size description
    this.space = '';
    let servingSize = this.getServingSizeListItem(index);

    let servingSizeConfig;
    if (servingSize) {
      servingSizeConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none" detail="false">
          <ion-note slot="start" mode="ios">
            <div class="f-12">${servingSize[0]}</div>
            <span><b>${servingSize[1]}</b></span>
          </ion-note>
           <ion-note slot="end" mode="ios" class="value"><b>${servingSize[2]}</b></ion-note>
          </ion-item>`,
          "class": "smartlabel-border-width-4x serving-size"
        }
      }
    }
    //Calories
    let calorie = 0;

    calorie = this.getCalorieListItem(index);
    let calorieConfig;

    calorieConfig = {
      "ctrlName": "list-item",
      "config": {
        "label": `
          <ion-item lines="none" detail="false">
          <ion-note slot="start" mode="ios">
            <div class="f-12">Amount Per Serving</div>
            <span class="f-30">Calories</span>
          </ion-note>
          <ion-note slot="end" mode="ios" class="value"><span class="f-30">${calorie}</span></ion-note>
          </ion-item>`,
        "class": "smartlabel-border-width-4x calorie-count"
      }
    }

    //total fat : FAT
    let totalFat = this.getNutrientItem(index, 'FAT');
    let totalFatConfig;
    if (totalFat) {
      totalFatConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name"><span class="f-w-700">${totalFat[0]}</span> ${totalFat[1]} ${totalFat[2]}</ion-note>
            <ion-note slot="end" mode="ios"><span class="f-w-700">${totalFat[3]}</span></ion-note>
          </ion-item>`
        }
      }
    }
    //saturated fat: FASAT
    let satFat = this.getNutrientItem(index, 'FASAT');
    let satFatConfig;
    if (satFat) {
      satFatConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
          <ion-note slot="start" mode="ios" class="nutrient-name">${satFat[0]} ${satFat[1]} ${satFat[2]}</ion-note>
            <ion-note slot="end" mode="ios"><span class="f-w-700">${satFat[3]}</span></ion-note>
          </ion-item>`,
          "class": "offset-15"
        }
      }
    }
    //Trans fat: FATRN

    let transFat = this.getNutrientItem(index, 'FATRN');
    let transFatConfig;
    if (transFat) {
      transFatConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name">${transFat[0]} ${transFat[1]} ${transFat[2]}</ion-note>
            <ion-note slot="end" mode="ios"><span class="f-w-700">${transFat[3]}</span></ion-note>
          </ion-item>`,
          "class": "offset-15"
        }
      }
    }
    //Polysaturated fat: FAPU
    let polyFat = this.getNutrientItem(index, 'FAPU');
    let polyFatConfig;
    if (polyFat) {
      polyFatConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name">${polyFat[0]} ${polyFat[1]} ${polyFat[2]}</ion-note>
            <ion-note slot="end" mode="ios"><span class="f-w-700">${polyFat[3]}</span></ion-note>
          </ion-item>`,
          "class": "offset-15"
        }
      }
    }
    //Monosaturated fat: FAMS
    let monoFat = this.getNutrientItem(index, 'FAMS');
    let monoFatConfig;
    if (monoFat) {
      monoFatConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name">${monoFat[0]} ${monoFat[1]} ${monoFat[2]}</ion-note>
            <ion-note slot="end" mode="ios"><span class="f-w-700">${monoFat[3]}</span></ion-note>
          </ion-item>`,
          "class": "offset-15"
        }
      }
    }

    //Cholestrol: CHOL-
    let cholestrol = this.getNutrientItem(index, 'CHOL-');
    let cholestrolConfig;
    if (cholestrol) {
      cholestrolConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none" >
            <ion-note slot="start" mode="ios" class="nutrient-name"><span class="f-w-700">${cholestrol[0]}</span> ${cholestrol[1]} ${cholestrol[2]}</ion-note>
            <ion-note slot="end" mode="ios"><span class="f-w-700">${cholestrol[3]}</span></ion-note>
          </ion-item>`
        }
      }
    }
    //Sodium: NA
    let sodium = this.getNutrientItem(index, 'NA');
    let sodiumConfig;
    if (sodium) {
      sodiumConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name"><span class="f-w-700">${sodium[0]}</span> ${sodium[1]} ${sodium[2]}</ion-note>
            <ion-note slot="end" mode="ios"><span class="f-w-700">${sodium[3]}</span></ion-note>
          </ion-item>`
        }
      }
    }
    //Total Carbohydrate: CHO-
    let carbohydrate = this.getNutrientItem(index, 'CHO-');
    let carbohydrateConfig;
    if (carbohydrate) {
      carbohydrateConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name"><span class="f-w-700">${carbohydrate[0]}</span> ${carbohydrate[1]} ${carbohydrate[2]}</ion-note>
            <ion-note slot="end" mode="ios"><span class="f-w-700">${carbohydrate[3]}</span></ion-note>
          </ion-item>`
        }
      }
    }
    //Dietary Fiber: FIBTG
    let dietaryFiber = this.getNutrientItem(index, 'FIBTG');
    let dietaryFiberConfig;
    if (dietaryFiber) {
      dietaryFiberConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name">${dietaryFiber[0]} ${dietaryFiber[1]} ${dietaryFiber[2]}</ion-note>
            <ion-note slot="end" mode="ios"><span class="f-w-700">${dietaryFiber[3]}</span></ion-note>
          </ion-item>`,
          "class": "offset-15"
        }
      }
    }

    //Total sugars: SUGAR-
    let totalSugars = this.getNutrientItem(index, 'SUGAR-');
    let totalSugarsConfig;
    if (totalSugars) {
      totalSugarsConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name">${totalSugars[0]} ${totalSugars[1]} ${totalSugars[2]}</ion-note>
            <ion-note slot="end" mode="ios"><span class="f-w-700">${totalSugars[3]}</span></ion-note>
          </ion-item>`,
          "class": "offset-15"
        }
      }
    }
    //Added sugar: SUGAD
    let addedSugar = this.getNutrientItem(index, 'SUGAD');
    let addedSugarConfig;
    if (addedSugar) {
      addedSugarConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name">${addedSugar[0]} ${addedSugar[1]} ${addedSugar[2]}</ion-note>
            <ion-note slot="end" mode="ios"><span class="f-w-700">${addedSugar[3]}</span></ion-note>
          </ion-item>`,
          "class": "offset-30"
        }
      }
    }
    //Protein: PRO-
    let protein = this.getNutrientItem(index, 'PRO-');
    let proteinConfig;
    if (protein) {
      proteinConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name"><span class="f-w-700">${protein[0]}</span> ${protein[1]} ${protein[2]}</ion-note>
            <ion-note slot="end" mode="ios"><span class="f-w-700">${protein[3]}</span></ion-note>
          </ion-item>`,
          "class": "smartlabel-border-width-2x"
        }
      }
    }

    let result = {
      "ctrlName": "list",
      "title": "",
      "config": {
        "class": "smartlabel-list nutrient-facts",
      },
      "controls": [
        ...(servingSizeConfig ? [servingSizeConfig] : []),
        ...(calorieConfig ? [calorieConfig] : []),
        {
          "ctrlName": "list-item",
          "config": {
            "label": `
            <ion-item lines="none">
            <ion-note slot="end" mode="ios"><span class="f-12">% Daily Value *</span></ion-note>
          </ion-item>`,
            "class": "text-bold"
          }
        },
        ...(totalFatConfig ? [totalFatConfig] : []),
        ...(satFatConfig ? [satFatConfig] : []),
        ...(transFatConfig ? [transFatConfig] : []),
        ...(polyFatConfig ? [polyFatConfig] : []),
        ...(monoFatConfig ? [monoFatConfig] : []),
        ...(cholestrolConfig ? [cholestrolConfig] : []),
        ...(sodiumConfig ? [sodiumConfig] : []),
        ...(carbohydrateConfig ? [carbohydrateConfig] : []),
        ...(dietaryFiberConfig ? [dietaryFiberConfig] : []),
        ...(totalSugarsConfig ? [totalSugarsConfig] : []),
        ...(addedSugarConfig ? [addedSugarConfig] : []),
        ...(proteinConfig ? [proteinConfig] : [])
      ]
    };
    //get micro nutrients list items
    let microNutrientsList: Array<any> = [];
    this.microNutrients_USA.map((item) => {
      //console.log("item", item, this.getMicroNutrients(0,item))
      //console.log("micronutrients index", index)
      let listItem = this.getMicroNutrients(index, item);
      if (listItem) {
        microNutrientsList.push(listItem)
      }
    });

    if (microNutrientsList.length > 0) {
      microNutrientsList.map((item, index) => {
        let widthClass: string = '';
        let microNutrientConfig;
        if (index === microNutrientsList.length - 1) {
          widthClass = "smartlabel-border-width-2x";
        }
        microNutrientConfig = {
          "ctrlName": "list-item",
          "config": {
            "label": `
              <ion-item lines="none" detail="false">
                <ion-note slot="start" mode="ios" class="nutrient-name">${item[0]} ${item[1]}${item[2]}</ion-note>
                <ion-note slot="end" mode="ios">${item[3] || item[3] === 0 ? `${item[3]}%` : ''}</ion-note>
              </ion-item>`,
            "class": `${widthClass}`
          }
        }
        //console.log("micronutrientConfig", microNutrientConfig)
        result.controls.push(microNutrientConfig);

      });

    }
    return result;
  }


  /**
   * return list control for nutrition Facts CA
   * @author Radhika Agnihotri
   * @tasK QLIKTAG-2898
   */
  getNutritionFacts_CA(index: number) {
    //console.log("getNutritionFacts_CA index", index);
    let result;
    //add space between dailyValueIntakePercent %, value and UOM code
    this.space = ' ';
    let per = [
      {
        "languageCode": "en",
        "value": "Per"
      },
      {
        "languageCode": "fr",
        "value": "Pour"
      },
      {
        "languageCode": "en_CA",
        "value": "Per"
      },
      {
        "languageCode": "fr_CA",
        "value": "Pour"
      },
      {
        "languageCode": "en_US",
        "value": "Per"
      }
    ]
    let dailyValueText = this.multiLangPipe.transform(this.dailyValue);

    let servingSize = this.getServingSizeListItem(index);

    let servingSizeConfig;
    if (servingSize) {
      //console.log("servingsize", servingSize)
      let perText = this.multiLangPipe.transform(per);
      servingSizeConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none" detail="false">
           <ion-note slot="start" mode="ios" class="value"><b>${perText} ${servingSize[2]}</b></ion-note>
          </ion-item>`,
          "class": "smartlabel-border-width-2x serving-size"
        }
      }
    }
    //Calories
    let calorie = 0;
    calorie = this.getCalorieListItem(index);
    let calorieConfig;

    calorieConfig = {
      "ctrlName": "list-item",
      "config": {
        "label": `
          <ion-item lines="none" detail="false">
          <ion-note class="smartlabel-border-width-4x m-r-5" slot="start" mode="ios">
            <span class="f-30">Calories ${calorie}</span>
          </ion-note>
          <ion-note slot="end" mode="ios" style="align-self:center" class="f-w-400 m-l-0"><span class="f-15 f-w-400">${dailyValueText}</span></ion-note>
          </ion-item>`,
        "class": "no-border calorie-count"
      }
    }

    //total fat : FAT
    let totalFat = this.getNutrientItem(index, 'FAT');
    let totalFatConfig;
    if (totalFat) {
      totalFatConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name"><span class="f-w-700">${totalFat[0]}</span> ${totalFat[1]} ${totalFat[2]}</ion-note>
            <ion-note slot="end" mode="ios">${totalFat[3]}</ion-note>
          </ion-item>`,
          "class": ""
        }
      }
    }
    //saturated fat: FASAT
    let satFat = this.getNutrientItem(index, 'FASAT');
    let satFatConfig;
    if (satFat) {
      satFatConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
          <ion-note slot="start" mode="ios" class="nutrient-name">${satFat[0]} ${satFat[1]} ${satFat[2]}</ion-note>
            <ion-note slot="end" mode="ios">${satFat[3]}</ion-note>
          </ion-item>`,
          "class": "offset-15"
        }
      }
    }
    //Trans fat: FATRN

    let transFat = this.getNutrientItem(index, 'FATRN');
    let transFatConfig;
    if (transFat) {
      transFatConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name">+ ${transFat[0]} ${transFat[1]} ${transFat[2]}</ion-note>
            <ion-note slot="end" mode="ios">${transFat[3]}</ion-note>
          </ion-item>`,
          "class": "offset-15"
        }
      }
    }
    //Polysaturated fat: FAPU
    let polyFat = this.getNutrientItem(index, 'FAPU');
    let polyFatConfig;
    if (polyFat) {
      polyFatConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name">${polyFat[0]} ${polyFat[1]} ${polyFat[2]}</ion-note>
            <ion-note slot="end" mode="ios">${polyFat[3]}</ion-note>
          </ion-item>`,
          "class": "offset-15"
        }
      }
    }
    //Monosaturated fat: FAMS
    let monoFat = this.getNutrientItem(index, 'FAMS');
    let monoFatConfig;
    if (monoFat) {
      monoFatConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name">${monoFat[0]} ${monoFat[1]} ${monoFat[2]}</ion-note>
            <ion-note slot="end" mode="ios">${monoFat[3]}</ion-note>
          </ion-item>`,
          "class": "offset-15"
        }
      }
    }

    //Cholestrol: CHOL-
    let cholestrol = this.getNutrientItem(index, 'CHOL-');
    let cholestrolConfig;
    if (cholestrol) {
      cholestrolConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none" >
            <ion-note slot="start" mode="ios" class="nutrient-name"><span class="f-w-700">${cholestrol[0]}</span> ${cholestrol[1]} ${cholestrol[2]}</ion-note>
            <ion-note slot="end" mode="ios">${cholestrol[3]}</ion-note>
          </ion-item>`
        }
      }
    }
    //Sodium: NA
    let sodium = this.getNutrientItem(index, 'NA');
    let sodiumConfig;
    if (sodium) {
      sodiumConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name"><span class="f-w-700">${sodium[0]}</span> ${sodium[1]} ${sodium[2]}</ion-note>
            <ion-note slot="end" mode="ios">${sodium[3]}</ion-note>
          </ion-item>`,
          "class": "smartlabel-border-width-2x"
        }
      }
    }
    //Total Carbohydrate: CHO-
    let carbohydrate = this.getNutrientItem(index, 'CHO-');
    let carbohydrateConfig;
    if (carbohydrate) {
      carbohydrateConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name"><span class="f-w-700">${carbohydrate[0]}</span> ${carbohydrate[1]} ${carbohydrate[2]}</ion-note>
            <ion-note slot="end" mode="ios">${carbohydrate[3]}</ion-note>
          </ion-item>`,
          "class": ""
        }
      }
    }
    //Dietary Fiber: FIBTG
    let dietaryFiber = this.getNutrientItem(index, 'FIBTG');
    let dietaryFiberConfig;
    if (dietaryFiber) {
      dietaryFiberConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name">${dietaryFiber[0]} ${dietaryFiber[1]} ${dietaryFiber[2]}</ion-note>
            <ion-note slot="end" mode="ios">${dietaryFiber[3]}</ion-note>
          </ion-item>`,
          "class": "offset-15"
        }
      }
    }

    //Total sugars: SUGAR-
    let totalSugars = this.getNutrientItem(index, 'SUGAR-');
    let totalSugarsConfig;
    if (totalSugars) {
      totalSugarsConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name">${totalSugars[0]} ${totalSugars[1]} ${totalSugars[2]}</ion-note>
            <ion-note slot="end" mode="ios">${totalSugars[3]}</ion-note>
          </ion-item>`,
          "class": "offset-15"
        }
      }
    }
    //Added sugar: SUGAD
    let addedSugar = this.getNutrientItem(index, 'SUGAD');
    let addedSugarConfig;
    if (addedSugar) {
      addedSugarConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name">${addedSugar[0]} ${addedSugar[1]} ${addedSugar[2]}</ion-note>
            <ion-note slot="end" mode="ios">${addedSugar[3]}</ion-note>
          </ion-item>`,
          "class": "offset-30"
        }
      }
    }
    //Protein: PRO-
    let protein = this.getNutrientItem(index, 'PRO-');
    let proteinConfig;
    if (protein) {
      proteinConfig = {
        "ctrlName": "list-item",
        "config": {
          "label": `
          <ion-item lines="none">
            <ion-note slot="start" mode="ios" class="nutrient-name"><span class="f-w-700">${protein[0]}</span> ${protein[1]} ${protein[2]}</ion-note>
            <ion-note slot="end" mode="ios">${protein[3]}</ion-note>
          </ion-item>`
        }
      }
    }
    //append class no-border to all items except last of fats list
    let fats = [
      ...(totalFatConfig ? [totalFatConfig] : []),
      ...(satFatConfig ? [satFatConfig] : []),
      ...(transFatConfig ? [transFatConfig] : []),
      ...(polyFatConfig ? [polyFatConfig] : []),
      ...(monoFatConfig ? [monoFatConfig] : []),
    ]
    if (fats.length > 1) {
      fats.map((item, index) => {
        //if it is not last index append no-border class
        if (index != fats.length - 1) {
          item['config']['class'] += ' no-border'
        }
      })
    }
    //append class no-border to all items except last of carbohydrates list
    let carbohydrates = [
      ...(carbohydrateConfig ? [carbohydrateConfig] : []),
      ...(dietaryFiberConfig ? [dietaryFiberConfig] : []),
      ...(totalSugarsConfig ? [totalSugarsConfig] : []),
      ...(addedSugarConfig ? [addedSugarConfig] : []),
    ];
    if (carbohydrates.length > 1) {
      carbohydrates.map((item, index) => {
        if (index != carbohydrates.length - 1) {
          item['config']['class'] += ' no-border'
        }
      })
    }

    result = {
      "ctrlName": "list",
      "title": "",
      "config": {
        "class": "smartlabel-list nutrient-facts",
      },
      "controls": [
        ...(servingSizeConfig ? [servingSizeConfig] : []),
        ...(calorieConfig ? [calorieConfig] : []),
        ...fats,
        ...carbohydrates,
        ...(proteinConfig ? [proteinConfig] : []),
        ...(cholestrolConfig ? [cholestrolConfig] : []),
        ...(sodiumConfig ? [sodiumConfig] : []),

      ]
    };
    //get micro nutrients list items
    let microNutrientsList: Array<any> = [];
    this.microNutrients_CA.map((item) => {
      let listItem = this.getMicroNutrients(index, item);
      if (listItem) {
        microNutrientsList.push(listItem)
      }
    });

    if (microNutrientsList.length > 0) {
      microNutrientsList.map((item, index) => {
        let widthClass: string = '';
        let microNutrientConfig;
        if (index === microNutrientsList.length - 1) {
          widthClass = "smartlabel-border-width-2x";
        }
        microNutrientConfig = {
          "ctrlName": "list-item",
          "config": {
            "label": `
              <ion-item lines="none" detail="false">
                <ion-note slot="start" mode="ios" class="nutrient-name">${item[0]} ${item[1]} ${item[2]}</ion-note>
                <ion-note slot="end" mode="ios">${item[3] || item[3] === 0 ? `${item[3]} %` : ''}</ion-note>
              </ion-item>`,
            "class": `${widthClass}`
          }
        }
        result.controls.push(microNutrientConfig);

      });

    }
    return result;
  }

  /**
   * get micronutrients based on nutrientCode
   * @param index [index of the nutrientHeader]
   * @param microNutrientCode [nutrientCode]
   * @author Radhika Agnihotri
   * @task QLIKTAG-2898
   */
  getMicroNutrients(index: number, microNutrientCode: string) {
    //console.log("micronutrientCode", microNutrientCode)
    let result;
    //get index
    let nutrientDetailPath = `data.modules.NutritionalProductInformationModuleType.nutrientHeader.${index}.nutrientDetail`
    let path = nutrientDetailPath.split('.');
    const nutrientDetail = this.appService.findObjectByPath(this.smartLabelData, path);
    let nutrientIndex: number = -1;
    if (nutrientDetail) {
      nutrientIndex = nutrientDetail.findIndex(item => item.nutrientTypeCode === microNutrientCode);
    }
    //console.log("nutrientDetail", nutrientDetail, nutrientIndex)
    //1. nutrientCode
    let nutrientCode = '';
    let nutrientValue = '';
    let measurementUnitCode = '';
    let dailyValueIntakePercent = '';

    //check if value is present in nutrientDetail array
    if (nutrientIndex != -1) {
      let nutrientItem = nutrientDetail[nutrientIndex];
      //1. nutrientCode ex. Vitamin A for VITA-
      nutrientCode = this.shortCodePipe.transform(`{{SL.${nutrientDetailPath}.${nutrientIndex}.nutrientTypeCode| mapTo: listItemName}}`);
      //3.a Nutrient Value ex. 500mg
      if (nutrientItem.hasOwnProperty('quantityContained') && nutrientItem['quantityContained'].length > 0) {
        if (nutrientItem['quantityContained'][0].hasOwnProperty('value')) {
          nutrientValue = nutrientItem['quantityContained'][0]['value'].toString();
        }
        if (nutrientValue && nutrientValue != '') {
          measurementUnitCode = this.shortCodePipe.transform(`{{SL.${nutrientDetailPath}.${nutrientIndex}.quantityContained.0.measurementUnitCode | mapTo: listItemName}}`);
        }

      }
      //3.b Measurement unit code

      //4. percentage value ex. 0% 
      if (nutrientItem.hasOwnProperty('dailyValueIntakePercent')) {
        dailyValueIntakePercent = nutrientItem['dailyValueIntakePercent']
      }
      //update result value only if item for nutrientCode is present in the data
      //console.log("measurementPrecisionCode", measurementPrecisionCode)
      result = [nutrientCode, nutrientValue, measurementUnitCode, dailyValueIntakePercent];
    }
    return result;
  }

  /**
   * get smartlabel-selector config for servingSize dropdown
   * @author Radhika Agnihotri
   * @task QLIKTAG-3584
   */
  getServingSizeSelectorConfig() {
    let result;
    let nutrientHeaderPath = `data.modules.NutritionalProductInformationModuleType.nutrientHeader`;
    let path = nutrientHeaderPath.split('.');
    const nutrientHeader = this.appService.findObjectByPath(this.smartLabelData, path);
    let options: Array<any> = [];

    const targetMarketPath = 'product.targetMarket';
    path = targetMarketPath.split('.');
    const targetMarket = this.appService.findObjectByPath(this.smartLabelData, path);
    //console.log("targetMarket", targetMarket)
    if (targetMarket && targetMarket === '124') {
      this.space = ' ';
    } else {
      this.space = '';
    }

    if (nutrientHeader && Array.isArray(nutrientHeader) && nutrientHeader.length > 1) {
      //check for servingSizeDescription in nutrientHeader array
      nutrientHeader.map((item, index) => {
        //check if servingSizeDescriptionProperty is present
        if (item.hasOwnProperty('servingSizeDescription')) {
          let label = this.multiLangPipe.transform(item['servingSizeDescription']);
          if (label && label != '') {
            options.push({
              "label": `${label}`,
              "value": index
            })
          } //check if servingSize property is present
        } else if (item.hasOwnProperty('servingSize') && Array.isArray(item['servingSize'])) {
          let label = '';
          if (item['servingSize'].length > 0) {
            item['servingSize'].map((element, servingSizeIndex) => {
              let measurementUnitCode = this.shortCodePipe.transform(`{{SL.${nutrientHeaderPath}.${index}.servingSize.${servingSizeIndex}.measurementUnitCode | mapTo: listItemName}}`);
              if (servingSizeIndex == 0) {
                label += `${element['value']} ${this.space}${measurementUnitCode}`;
              } else {
                label += ` (${element['value']}${this.space}${measurementUnitCode})`;
              }
            });
            //format selector options
            if (label && label != '') {
              options.push({
                "label": `${label}`,
                "value": index
              });
            }
          }
        }
      });

      //format result
      result = {
        "ctrlName": "smartlabel-selector",
        "config": {
          "type": "serving-size",
          "options": options,
          "class": "smartlabel-selector"
        }
      };
    }
    return result;
  }

  /**
  * Get Features and Benefits
  * @author Venkatesh Pasala
  * @task QLIKTAG-2901
  */
  getFeaturesAndBenefitsConfig() {
    let listConfig;
    let item;
    listConfig = {
      "ctrlName": "list",
      "title": FOOD_LANG["feature-and-benefits"],
      "config": {
        "class": "smartlabel-list",
      },
      "controls": []
    };
    if (this.smartLabelService.getAboutProductFoodPageList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": FOOD_LANG["feature-and-benefits"],
          "url": { "url": `p/${this.pageAlias}?detail=about-this-product`, "type": "detail" },
          "class": "p-start-0 p-end-0 inner-p-start-15 inner-p-end-15"
        }
      };
      listConfig.controls.push(item);
    }
    if (this.smartLabelService.getCertificationsFoodPageList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": FOOD_LANG["certifications"],
          "url": { "url": `p/${this.pageAlias}?detail=certifications-item`, "type": "detail" },
          "class": "p-start-0 p-end-0 inner-p-start-15 inner-p-end-15"
        }
      };
      listConfig.controls.push(item);
    }
    if (this.smartLabelService.getProductUsageAndSafetyFoodPageList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": FOOD_LANG["health-safety"],
          "url": { "url": `p/${this.pageAlias}?detail=health-and-safety`, "type": "detail" },
          "class": "p-start-0 p-end-0 inner-p-start-15 inner-p-end-15"
        }
      };
      listConfig.controls.push(item);
    }
    if (this.smartLabelService.getProductInstructionsFoodPageList()) {
      item = {
        "ctrlName": "list-item",
        "config": {
          "label": FOOD_LANG["product-instructions"],
          "url": { "url": `p/${this.pageAlias}?detail=product-instructions`, "type": "detail" },
          "class": "p-start-0 p-end-0 inner-p-start-15 inner-p-end-15"
        }
      };
      listConfig.controls.push(item);
    }
    return listConfig;
  }

  /**
   * get array of listItem values [nutrientName, measurementPrecision, quantityContained, dailyValueIntakePercent]
   * @returns Array<string> if nutrientCode present in nutrientDetail array or returns undefined
   * @author Radhika Agnihotri
   * @task QLIKTAG-2898
   */
  getNutrientItem(index: number, nutrientCode: string) {
    let result;
    let [nutrientName, measurementPrecision, quantityContained, dailyValueIntakePercent] = ['', '', '', ''];

    let nutrientDetailPath = `data.modules.NutritionalProductInformationModuleType.nutrientHeader.${index}.nutrientDetail`
    let path = nutrientDetailPath.split('.');
    const nutrientDetail = this.appService.findObjectByPath(this.smartLabelData, path);
    let nutrientIndex: number = -1;

    if (nutrientDetail) {
      nutrientIndex = nutrientDetail.findIndex(item => item.nutrientTypeCode === nutrientCode);
    }
    //console.log("nutrientDetail",index, nutrientCode, nutrientDetail, nutrientIndex)
    //get nutrientName
    if (nutrientIndex != -1) {

      let nutrientItem = nutrientDetail[nutrientIndex];
      //console.log("nutrientIndex", nutrientIndex, nutrientItem)

      //1.get nutrientName by nutrientCode
      nutrientName = this.getNutrientName(nutrientDetailPath, nutrientIndex);

      //2. measurementPrecision ex. Less than
      if (nutrientItem.hasOwnProperty('measurementPrecision')) {
        if (nutrientItem['measurementPrecision'] != 'EXACT') {
          measurementPrecision = this.getMeasurementPrecision(nutrientDetailPath, nutrientIndex);
        }
      }

      //3. quantityContained ex. 5mg
      quantityContained = this.getQuantityContained(nutrientItem, nutrientDetailPath, nutrientIndex);
      //4. ex. 0%
      dailyValueIntakePercent = this.getDailyValueIntakePercent(nutrientItem);

      result = [nutrientName, measurementPrecision, quantityContained, dailyValueIntakePercent];

    }
    //console.log("result", result, nutrientCode)
    //if item not found return undefined
    return result;
  }

  /**
   * get nutrientName value using nutrientIndex ex. Cholestrol
   * @param nutrientDetailPath [Path to a particulat nutrientDetail]
   * @param nutrientIndex [index of element matching nutrientCode]
   * @author Radhika Agnihotri
   * @task QLIKTAG-2898
   */
  getNutrientName(nutrientDetailPath, nutrientIndex) {
    let result = this.shortCodePipe.transform(`{{SL.${nutrientDetailPath}.${nutrientIndex}.nutrientTypeCode| mapTo: listItemName}}`);
    return result;
  }

  /**
   * get measurementPrecision value using nutrientIndex ex. Less Than
   * @param nutrientDetailPath [Path to a particulat nutrientDetail]
   * @param nutrientIndex [index of element matching nutrientCode]
   * @author Radhika Agnihotri
   * @task QLIKTAG-2898
   */
  getMeasurementPrecision(nutrientDetailPath, nutrientIndex) {
    let result = this.shortCodePipe.transform(`{{SL.${nutrientDetailPath}.${nutrientIndex}.measurementPrecision| mapTo: listItemName}}`);
    return result;
  }

  /**
   * get quantityContained value using nutrientIndex ex. 5mg
   * @param nutrientItem [nutrientDetail object matching nutrientCode]
   * @param nutrientDetailPath [Path to a particulat nutrientDetail]
   * @param nutrientIndex [index of element matching nutrientCode]
   * @author Radhika Agnihotri
   * @task QLIKTAG-2898
   */
  getQuantityContained(nutrientItem: object, nutrientDetailPath: string, nutrientIndex: number) {
    let result = '';
    if (nutrientItem.hasOwnProperty('quantityContained') && nutrientItem['quantityContained'].length > 0) {
      if (nutrientItem['quantityContained'][0].hasOwnProperty('value')) {
        let value = nutrientItem['quantityContained'][0]['value'];
        let measurementUnitCode = this.shortCodePipe.transform(`{{SL.${nutrientDetailPath}.${nutrientIndex}.quantityContained.0.measurementUnitCode | mapTo: listItemName}}`);
        // result += measurementUnitCode;
        result = `${value}${this.space}${measurementUnitCode}`
      }
    }
    return result;
  }

  /**
   * get dailyValueIntakePercent value using nutrientItem
   * @param nutrientItem [nutrientDetail object matching nutrientCode]
   * @author Radhika Agnihotri
   * @task QLITKAG-2898
   */
  getDailyValueIntakePercent(nutrientItem) {
    let result = '';
    if (nutrientItem.hasOwnProperty('dailyValueIntakePercent')) {
      result = `${nutrientItem['dailyValueIntakePercent']}${this.space}%`;
    }
    return result;
  }
  /**
   * get nutrientHeader.{index}.servingSize values
   * @param index [selected serving size index]
   * @author Radhika Agnihotri
   * @task QLIKTAG-2898
   */
  getServingSizeListItem(index: number) {
    let result;
    let nutrientHeaderPath = `data.modules.NutritionalProductInformationModuleType.nutrientHeader.${index}`
    let path = nutrientHeaderPath.split('.');
    const nutrientHeader = this.appService.findObjectByPath(this.smartLabelData, path);
    let servingSizeDescription = '';
    let servingSize = '';
    let servingSizeText = 'Serving Size'
    //console.log("nutrientHeader", nutrientHeader);
    if (nutrientHeader) {
      if (nutrientHeader.hasOwnProperty('servingSizeDescription')) {
        servingSizeDescription = this.multiLangPipe.transform(nutrientHeader['servingSizeDescription']).toString();
      }
      if (nutrientHeader && nutrientHeader.hasOwnProperty('servingSize') && Array.isArray(nutrientHeader['servingSize'])) {
        if (nutrientHeader['servingSize'].length > 0) {
          nutrientHeader['servingSize'].map((element, servingSizeIndex) => {
            let measurementUnitCode = this.shortCodePipe.transform(`{{SL.${nutrientHeaderPath}.servingSize.${servingSizeIndex}.measurementUnitCode | mapTo: listItemName}}`);
            if (servingSizeIndex == 0) {
              servingSize += `${element['value']} ${this.space}${measurementUnitCode}`;
            } else {
              servingSize += ` (${element['value']}${this.space}${measurementUnitCode})`;
            }
          })
        }
      }
      result = [servingSizeDescription, servingSizeText, servingSize]
    }
    //console.log("Result", result)
    return result;
  }


  /**
   * get nutrientHeader.{index}.nutrientDetail values for code ENER- (calories)
   * @param index [selected serving size index]
   * @author Radhika Agnihotri
   * @task QLIKTAG-2898
   */
  getCalorieListItem(index: number) {
    let result;
    //get index
    let nutrientDetailPath = `data.modules.NutritionalProductInformationModuleType.nutrientHeader.${index}.nutrientDetail`;
    let path = nutrientDetailPath.split('.');
    const nutrientDetail = this.appService.findObjectByPath(this.smartLabelData, path);
    let nutrientIndex: number = -1;
    if (nutrientDetail) {
      nutrientIndex = nutrientDetail.findIndex(item => item.nutrientTypeCode === 'ENER-');
    }
    let calorieValue = '0';

    if (nutrientIndex != -1) {
      let calorieItem = nutrientDetail[nutrientIndex];
      if (calorieItem.hasOwnProperty('quantityContained') && calorieItem['quantityContained'].length > 0) {
        if (calorieItem['quantityContained'][0].hasOwnProperty('value')) {
          calorieValue = calorieItem['quantityContained'][0]['value'];
        }
      }
    }
    result = calorieValue;
    return result;
  }

  /** 
   * get allergens for food header config
   * @author Venkatesh Pasala
   * @task QLIKTAG-2900
   */
  getAllergensFoodHeaderConfig() {
    let listConfig = [];
    let attributeKey = 'product.targetMarket';
    if (this.smartLabelService.isProductEntity) {
      attributeKey = 'targetMarket';
    }
    listConfig.push({
      "ctrlName": "conditional",
      "config": {
        "source": "entityInformation",
        "action": "show",
        "operator": "matches",
        "mapping": {
          "attributeKey": attributeKey
        },
        "attributeValue": "840"
      },
      "controls": [
        {
          "ctrlName": "jumbotron",
          "config": {
            "class": "smartlabel-jumbotron m-r-15 m-l-15",
            "content": FOOD_LANG["allergens-info"]
          }
        }
      ]
    });
    listConfig.push({
      "ctrlName": "conditional",
      "config": {
        "source": "entityInformation",
        "action": "show",
        "operator": "matches",
        "mapping": {
          "attributeKey": attributeKey
        },
        "attributeValue": "124"
      },
      "controls": [
        {
          "ctrlName": "jumbotron",
          "config": {
            "class": "smartlabel-jumbotron m-r-15 m-l-15",
            "content": FOOD_LANG["ca-allergens-info"]
          }
        }
      ]
    });
    return listConfig;
  }

  /**
   * get allergens list for food 
   * @author Venkatesh Pasala
   * @task QLIKTAG-2900
   */
  getAllergensFoodListConfig() {
    let allergensListResult = [];
    let allergensInfoList = this.getAllergensFoodList();
    if (allergensInfoList && allergensInfoList.controls && allergensInfoList.controls.length) {
      allergensListResult.push({
        "ctrlName": "list",
        "config": {
          "class": "smartlabel-list m-l-15 m-r-15"
        },
        "controls": [
          allergensInfoList
        ]
      });
    } else {
      allergensListResult.push({
        "ctrlName": "rich-text",
        "config": {
          "class": "smartlabel-rich-text p-30",
          "content": FOOD_LANG["no-allergens"]
        }
      });
    }
    return allergensListResult;
  }

  /**
    * get allergen listItem
    * @author Venkatesh Pasala
    * @task QLIKTAG-2900
    */
  getAllergensFoodList() {
    let allergensList: any;
    allergensList = {
      "ctrlName": "list",
      "config": {
        "class": "smartlabel-list"
      },
      "controls": []
    }
    let allergenRelatedInformationPath = "data.modules.ProductAllergenInformationModuleType.allergenRelatedInformation";
    let path = allergenRelatedInformationPath.split(".");
    let allergenRelatedInformation = this.appService.findObjectByPath(this.smartLabelData, path);

    //console.log({allergenRelatedInformation});
    let targetMarket = '840'

    const targetMarketPath = 'product.targetMarket';
    path = targetMarketPath.split('.');
    targetMarket = this.appService.findObjectByPath(this.smartLabelData, path);
    let allergenCodes = [];


    if (targetMarket) {

      if (targetMarket == '840') {
        allergenCodes = this.allergenCodes_USA;
      } else {
        allergenCodes = this.allergenCodes_CA;
      }

    }

    //console.log({allergenCodes});


    let allergenTypeCode = '';
    let levelOfContainmentCode = '';
    if (allergenRelatedInformation && allergenRelatedInformation.length > 0) {

      allergenCodes.forEach((ac, acIndex) => {

        allergenRelatedInformation.map((element, allergenRelatedInformationIndex) => {
          if (element.hasOwnProperty("allergen") && Array.isArray(element.allergen)) {
            if (element.allergen.length > 0) {

              //CHECK if AC is present in allergen array

              let found = element.allergen.findIndex((a) => {
                return ac.toLowerCase() == a.allergenTypeCode.toLowerCase();
              });

              if (found != -1) {
                //console.log({ac, found});

                let allergenListItem = this.formatAllergenListItem(
                  allergenRelatedInformationPath,
                  allergenRelatedInformationIndex,
                  found

                );
                if (allergenListItem) {
                  allergensList.controls.push(allergenListItem);


                }


              }


            }
          }
        });



      });


      //REPEAT FOR ADDITIONAL ITEMS
      allergenRelatedInformation.map((element, allergenRelatedInformationIndex) => {
        if (element.hasOwnProperty("allergen") && Array.isArray(element.allergen)) {
          if (element.allergen.length > 0) {

            element.allergen.forEach((a, index) => {

              let found = allergenCodes.findIndex((ac) => {
                return ac.toLowerCase() == a.allergenTypeCode.toLowerCase();
              });

              if (found == -1) {
                let allergenListItem = this.formatAllergenListItem(
                  allergenRelatedInformationPath,
                  allergenRelatedInformationIndex,
                  index

                );

                if (allergenListItem) {
                  allergensList.controls.push(allergenListItem);
                }
              }


            });
          }
        }
      });


      return allergensList;
    }
  }

  /**
   * Format allergen item into listItemConfig
   * @param allergenRelatedInformationPath: Allergen Information array containing subarrays
   * @param allergenRelatedInformationIndex: Index of subarray
   * @param found: index of item in subarray
   * @author Neil C
   * @task QLIKTAG-3694
   */
  formatAllergenListItem(allergenRelatedInformationPath, allergenRelatedInformationIndex, found) {
    let listItem;

    let allergenTypeCode = this.shortCodePipe.transform(`{{SL.${allergenRelatedInformationPath}.${allergenRelatedInformationIndex}.allergen.${found}.allergenTypeCode | mapTo: listItemName}}`);

    let levelOfContainmentCode = this.shortCodePipe.transform(`{{SL.${allergenRelatedInformationPath}.${allergenRelatedInformationIndex}.allergen.${found}.levelOfContainmentCode | mapTo: listItemName}}`);

    //console.log(allergenTypeCode, levelOfContainmentCode)

    if (allergenTypeCode && levelOfContainmentCode) {
      listItem = {
        "ctrlName": "list-item",
        "config": {
          "class": "p-start-0 p-end-0 inner-p-start-15 inner-p-end-15",
          "label": `
          <ion-badge class="smartlabel-badge" mode="ios" style="float: right;">${levelOfContainmentCode}</ion-badge>
          <ion-label class="smartlabel-list m-0" mode="ios">${allergenTypeCode}</ion-label>
          `,
          "url": { "url": `p/${this.pageAlias}?detail=allergen-item&listIndex=${allergenRelatedInformationIndex}_${found}`, "type": "detail" }
        }
      };
    }



    return listItem;
  }


  /**
   * QLIKTAG-4002
   * @param ingredientsList 
   * @param listIndex 
   * @param level 
   * @returns 
   */

  getFoodIngredientsListConfig(ingredientsList: Array<any>, listIndex?, level = 0) {

    const nestedKey = 'subIngredient';
    let nestedIndex;
    const pageLinks = [
      { "url": `p/${this.pageService.pageAlias}?detail=ingredient-item-food`, "type": "detail" },
      { "url": `p/${this.pageService.pageAlias}?detail=sub-ingredient-item-food`, "type": "detail" },
      { "url": `p/${this.pageService.pageAlias}?detail=sub-ingredient-item-food`, "type": "detail" },
      { "url": `p/${this.pageService.pageAlias}?detail=sub-ingredient-item-food`, "type": "detail" },
      { "url": `p/${this.pageService.pageAlias}?detail=sub-ingredient-item-food`, "type": "detail" },
    ]

    let result = {
      "ctrlName": "list",
      "config": {
        "class": "smartlabel-list ingredient-list"
      },
      "controls": []
    }

    if (ingredientsList && ingredientsList.length > 0) {

      let listItem;
      let itemListConfig;
      ingredientsList.forEach((item, index) => {
        nestedIndex = listIndex ? `${listIndex}_${index}` : `${index}`;
        listItem = {
          "ctrlName": "list-item",
          "config": {
            "label": item.hasOwnProperty('ingredientName') ?
              `${this.multiLangPipe.transform(item.ingredientName)}` : '',
            "content": '',
            "url": this.formatPageLinkURL(pageLinks[level], nestedIndex),
            "class": "ingredient-item"
          },
          "controls": []
        }
        if (item.hasOwnProperty(nestedKey)) {
          level = level + 1;
          itemListConfig = this.getFoodIngredientsListConfig(item[nestedKey], nestedIndex, level);


          if (level != 0) {
            level = level - 1;
          }
          if (itemListConfig) {
            if (itemListConfig.hasOwnProperty("config") && itemListConfig.config.hasOwnProperty("class")) {
              itemListConfig.config.class = "smartlabel-list ingredient-list nested-ingredients-list";
            }
            listItem.controls.push(itemListConfig);
          }
        }

        result.controls.push(listItem);
      });
    }
    //console.log("result", result)
    return result;
  }


  /**
   * get ingredients list config
   * @author Radhika Agnihotri
   * @task QLIKTAG-3845
   */
  getIngredientsList() {
    let result;
    let path = this.foodIngredientInformationPath.split(".");
    let ingredients = this.appService.findObjectByPath(this.smartLabelData, path);
    if (ingredients) {
      if (ingredients.hasOwnProperty('foodAndBeverageIngredient') && ingredients.foodAndBeverageIngredient && Array.isArray(ingredients.foodAndBeverageIngredient) && ingredients.foodAndBeverageIngredient.length > 0) {
        result = this.getFoodIngredientsListConfig(ingredients.foodAndBeverageIngredient);
        //console.log("final result", result)
        //console.log("ingreidentslistconfig", result)
      } else if (ingredients.hasOwnProperty('ingredientStatement') && ingredients.ingredientStatement) {
        result = this.getIngredientsByStatement(ingredients.ingredientStatement);

      }
    }
    return result;
  }

  /**
   * get ingredient list by statement
   * @param ingredientStatement [ingredientStatement]
   * @author Radhika Agnihotri
   * @task QLIKTAG-3845
   */
  getIngredientsByStatement(ingredientStatement) {
    let list: any;
    let controls = [];
    let ingredientsList;

    if (ingredientStatement) {
      let ingredientsByStatement = this.multiLangPipe.transform(JSON.parse(JSON.stringify(ingredientStatement)));
      if (typeof (ingredientsByStatement) === 'string') {
        ingredientsList = ingredientsByStatement.split(/,(?![^(]*\))/);
      }
    }
    if (ingredientsList && ingredientsList.length > 0) {

      for (const ingredient of ingredientsList) {
        controls.push(
          {
            "ctrlName": "list-item",
            "config": {
              "label": ingredient
            }
          },
        )
      }
      if (controls.length > 0) {
        list = {
          "ctrlName": "list",
          "title": "Ingredients List",
          "config": {
            "class": "smartlabel-list ingredient-list"
          },
          "controls": controls
        }
      }
    }
    return [list];
  }

  formatPageLinkURL(pageLink, listIndex) {
    //console.log("listIndex", listIndex)
    if (pageLink) {
      let link = JSON.parse(JSON.stringify(pageLink));
      if (listIndex) {

        if (link.hasOwnProperty('url')) {

          link.url += `&listIndex=${listIndex}`;
        }

      }
      return link;
    }
  }
}

